import MobileConsentSolutionsEdit from './MobileConsentSolutionsEdit';

export default MobileConsentSolutionsEdit;
